import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import AxiosController from "../authentication/AxiosController";
import { notifyError, notifySuccess } from "../toastify/toastify";

const LevelsAddAndUpdate = ({ show,  setShow,  showImageEdit,  setShowImageEdit,  id,  update,  data,  fetchLevels,}) => {
  const { slug, lang } = useParams();
  const token = localStorage.getItem("token");
  const { t } = useTranslation("global");
  const [loading, handleLoader] = useState(false);
  const [commission, setCommission] = useState(0);
  const [target, setTarget] = useState(0);
  const [level, setLevel] = useState("");
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (data) {
      setCommission(data?.commission);
      setTarget(data?.target);
      setLevel(data?.level);
      setImage(data?.image_url);
    }
  }, [data]);
  const createOrUpdatelevels = () => {
    handleLoader(true);
    const url = update
      ? `api/${slug}/${lang}/level/update-level/${id}`
      : `api/${slug}/${lang}/level/add-level`;
    const method = update ? "put" : "post";
 
    AxiosController[method](
      url,
      {
        commission,
        level,
        target,
        ...(!update && { image }),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(!update && { "Content-Type": "multipart/form-data" }),
        },
      }
    )
      .then((res) => {
        notifySuccess(t("panel.updateSuccessMsg"))
        fetchLevels();
        handleLoader(false);
        handleClose();
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.error) {
          const errors = e.response.data.error;
          Object.entries(errors).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((err) => notifyError(`${key}: ${err}`));
            } else {
              notifyError(`${key}: ${value}`);
            }
          });
        } else {
          notifyError("An unexpected error occurred.");
        }
        handleLoader(false);
      });
  };

  const UpdateImagelevels = () => {
    handleLoader(true);
    AxiosController.post(
      `api/${slug}/${lang}/level/update-image/${id}`,
      {
        image,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((res) => {
        notifySuccess(t("panel.updateSuccessMsg"))
        handleCloseImage();
        fetchLevels();
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
        if (e.response && e.response.data && e.response.data.error) {
          const errors = e.response.data.error;
          Object.entries(errors).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((err) => notifyError(`${key}: ${err}`));
            } else {
              notifyError(`${key}: ${value}`);
            }
          });
        } else {
          notifyError("An unexpected error occurred.");
        }
      });
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleCloseImage = () => {
    setShowImageEdit(false);
    setImage(data?.image_url);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="flex-grow-1">
            {update ? t("panel.updateLevel") : t("panel.addLevel")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!update && (
            <div className="mb-3">
              <label className="form-label">{t("panel.image")}</label>
              <input
                type="file"
                className="form-control py-2"
                onChange={(e) => setImage(e.target.files[0])}
              />
              {image && (
                <div className="mt-3">
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Selected"
                    className="img-thumbnail"
                    style={{ maxWidth: "200px", maxHeight: "200px" }}
                  />
                </div>
              )}
            </div>
          )}
          {labelInput(
            t("panel.affiliatesCommission"),
            commission,
            setCommission
          )}
          {labelInput(t("panel.target"), target, setTarget)}

          {labelInput(t("panel.affiliatesLevel"), level, setLevel)}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" onClick={createOrUpdatelevels}>
            {t("panel.save")}
          </Button>
          <Button variant="danger" onClick={handleClose}>
            {t("panel.cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showImageEdit} onHide={handleCloseImage}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="flex-grow-1">
            {update ? t("panel.updateLevel") : t("panel.addLevel")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">{t("panel.image")}</label>
            <input
              type="file"
              className="form-control py-2"
              onChange={(e) => setImage(e.target.files[0])}
            />
            <div className="mt-3">
              {image instanceof Blob || image instanceof File ? (
                <img
                  src={URL.createObjectURL(image)}
                  alt="Selected"
                  className="img-thumbnail"
                  style={{ maxWidth: "200px", maxHeight: "200px" }}
                />
              ) : (
                <img
                  src={image}
                  alt="Selected"
                  className="img-thumbnail"
                  style={{ maxWidth: "200px", maxHeight: "200px" }}
                />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" onClick={UpdateImagelevels}>
            {t("panel.save")}
          </Button>
          <Button variant="danger" onClick={handleCloseImage}>
            {t("panel.cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LevelsAddAndUpdate;

const labelInput = (label, value, onChange) => (
  <div className="mb-3">
    <label className="form-label">{label}</label>
    <input
      type="text"
      className="form-control py-2"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
